export default {"src":"/_next/static/media/Bnb.fed918ea.svg","height":73,"width":73};